module.exports = __webpack_public_path__ + "static/media/sports.77852cde.jpg";